/**
 * @Author: v_jppjpeng
 * @Date: 2023-11-16 15:23:44
 * @Explain: 卡片
 */
import classNames from 'classnames';
import { useMemo } from 'react';
import type { CardProps } from 'tdesign-react';
import { Card as TdCard } from 'tdesign-react';
import type { PropsType as PageLoadingProps } from '../pageLoading';
import PageLoading from '../pageLoading';

type PropsType = {
  children?: CardProps['children'];
  className?: CardProps['className'];
  style?: CardProps['style'];
  title?: CardProps['title'];
  actions?: CardProps['actions'];
  header?: CardProps['header'];
  description?: CardProps['description'];
  bordered?: CardProps['bordered'];
  isShowBody?: boolean;
  footer?: CardProps['footer'];
  cardProps?: CardProps;
  loading?: boolean;
  pageLoadingProps?: PageLoadingProps;
  headerAlignBaseline?: boolean;
};

function Card(props: PropsType) {
  const {
    children,
    className,
    style,
    title,
    actions,
    header,
    description,
    bordered = false,
    isShowBody = true,
    footer,
    cardProps,
    loading = false,
    pageLoadingProps,
    headerAlignBaseline,
  } = props;

  // 自定义参数
  const customProps: CardProps = useMemo(
    () => ({
      header,
      title,
      actions,
      description,
      bordered,
      footer,
    }),
    [header, title, actions, description, bordered, footer],
  );
  return (
    <>
      <TdCard
        className={classNames(
          'default-td-card',
          { 'header-align-baseline': headerAlignBaseline },
          className,
        )}
        style={style}
        {...customProps}
        {...cardProps}
      >
        {isShowBody && (
          <>
            <PageLoading isShow={loading} {...pageLoadingProps} />
            {children}
          </>
        )}
      </TdCard>
    </>
  );
}

export default Card;
